import "./shareBillPOS.css";

import FacebookImg from "./share-logo/facebook.png";
import WhatsAppImg from "./share-logo/whatsapp.png";
import InstagramImg from "./share-logo/instagram.png";
import LinkedInImg from "./share-logo/linkedin.png";
import GmailImg from "./share-logo/gmail.png";
import YahooImg from "./share-logo/instagram.png";
import SmsImg from "./share-logo/sms.png";
import EmailImg from "./share-logo/gmail.png";
import TelegramImg from "./share-logo/telegram.png";

const shareOptions = [
  {
    name: "SMS",
    image: SmsImg,
  },
  {
    name: "WhatsApp",
    image: WhatsAppImg,
  },
  {
    name: "Gmail",
    image: GmailImg,
  },
  {
    name: "Facebook",
    image: FacebookImg,
  },

  {
    name: "Instagram",
    image: InstagramImg,
  },
  {
    name: "LinkedIn",
    image: LinkedInImg,
  },

  {
    name: "Yahoo",
    image: YahooImg,
  },

  {
    name: "Telegram",
    image: TelegramImg,
  },
];

export default function ShareBillPOS({ setAlert }) {
  const clientLevel = "standarfd";
  function handleShareClick(item) {
    if (clientLevel === "standard" || clientLevel === "professional") {
      setAlert({
        message:
          "Please upgrade your account to Enterprise-level or Premium-level to use this feature",
        type: "warning",
      });
    } else {
      setAlert({
        message:
          "This Component is currently under maintainance and will be back soon!",
        type: "info",
      });
    }
  }
  return (
    <div className="shareVia fx-cl spacem">
      <h2>Share Via</h2>
      <div className="g g4 space1">
        {shareOptions.map((item) => (
          <button
            key={item.name}
            className="shareCard fx-cl fx-jc fx-ac spacem"
            onClick={() => handleShareClick(item)}
          >
            <img src={item.image} alt={item.name} />
            <span>{item.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
